/*! Haus of MX – theme bootstrap (safe, idempotent) */
(() => {
  if (window.__haus_theme_bootstrap__) return;
  window.__haus_theme_bootstrap__ = true;

  // Helpers sin dependencias
  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const onReady = (fn) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn, { once: true })
      : fn();
  const onIdle = (fn) =>
    'requestIdleCallback' in window ? requestIdleCallback(fn) : setTimeout(fn, 0);

  // Flags por plantilla (no asumimos nodos que no existen)
  const isProduct   = document.body.classList.contains('template-product');
  const isCollection= document.body.classList.contains('template-collection');
  const isHome      = document.body.classList.contains('template-index');

  onReady(() => {
    // 1) Header: ejemplo de toggle sin modificar estilos/markup
    try {
      const navToggle = $('[data-nav-toggle]');
      const nav       = $('[data-nav]');
      if (navToggle && nav) {
        navToggle.addEventListener('click', () => nav.classList.toggle('is-open'));
      }
    } catch (e) { /* silencioso */ }

    // 2) Lógica SOLO para PDP (evita errores en otras páginas)
    if (isProduct) {
      try {
        // Ejemplo: abrir guía de tallas si existe
        const openBtn = $('[data-size-guide-open]');
        const modal   = $('#size-guide');
        if (openBtn && modal && typeof modal.showModal === 'function') {
          openBtn.addEventListener('click', () => modal.showModal());
        }
      } catch (e) { /* silencioso */ }
    }

    // 3) Inicializaciones no críticas en idle (carousels/widgets si existen)
    onIdle(() => {
      try {
        if (typeof window.initCarousels === 'function') window.initCarousels();
      } catch (e) { /* silencioso */ }
    });
  });
})();
